import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loadingState: false,
        token: null,
        user: null,
        tagTypes : null,
        breadCrump : {
            "title":"Dashboard",
            "items":[

                {
                    path: '/',
                 
                    name: 'route-index',
                    component: () => import('./views/company/list.vue'),
                    meta: {
                        auth: true,
                        label: "Home"
                    },
                }
            ]
        }
    },
  mutations: {
    changeLoadingState(state, { value }) {
      state.loadingState = value;
    },
    // 🎈 @mattia qui c'è la logica per l'autenticazione
      authUser(state, { user }) {
          state.token =user.token;
          state.user = user;
            localStorage.setItem('crm-api', JSON.stringify(user));

          
        axios.defaults.headers['Authorization'] = `Bearer ${state.token}`;
    },
      clearAuth(state) {
          state.token = null;
          state.user = null;
          localStorage.removeItem('crm-api');
          axios.defaults.headers['Authorization'] = null;
      }
     
  },
    actions: {
       
        login({ commit }, { username, password }) {
            var theToken = null;
            return axios
                .post('user/authenticate', {
                    username: username,
                    password: password
                })
        },
        autoLogin({ commit, dispatch }) {
            if(localStorage.getItem('crm-api')){
            var user = JSON.parse(localStorage.getItem('crm-api'));
            if (user != null) {
                commit('authUser', { user: user });
            } else {
                dispatch('logout');
            }
        }
    else{
        dispatch('logout');
    }
        },
        verifyToken({ commit }, { token }) {
            axios.defaults.headers['Authorization'] = `Bearer ${token}`;
            return axios
                .get('auth/verifytoken');

        },
        logout({ commit }) {
            commit('clearAuth');
        }
        ,
        fetchTagTypes({ commit }) {
           
            axios
                .get('tag/type/list').then(response => {
                    this.state.tagTypes = response.data;
                });

        }
       
  

    },
    getters: {
        isLoading: state => {
            return state.loadingState;
        },
        isAuthenticated: state => {
            return state.token != null;
        },
        isInRole: state =>(role) => {
            if(state.user)
            return state.user.roles.indexOf(role)!=-1;
            return false;
        }
    }
});
